import { SelectStub } from '@direct-frontend/components';

export const CharacteristicGroupSelectStub = () => <SelectStub size="m" color="contour" isDisabled />;
